export default __webpack_public_path__ + "static/media/step1.1bef77a9.png";